import { UserConstants } from '../constants';

const initialState = { cCreated: false, cCreating: false };


export function createCert(state = initialState, action) {
    switch (action.type) {
    case UserConstants.CERTIFICATE_REQUEST:
        return {
            cCreating: true,
            cCreated: false
        };
    case UserConstants.CERTIFICATE_SUCCESS:
        return {
            cCreating: false,
            cCreated: true,
        };
    case UserConstants.CERTIFICATE_ERROR:
        return{
            cCreated: false,
            cCreating: false
        };
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/CreateCReducer.jsx